/** Portal menü ↔ URL path eşlemesi (toplantı odası /:id ile çakışmasın) */

export const MENU_PATHS = {
  HOME: "/home",
  MESSAGING: "/messaging",
  DIRECTORY: "/directory",
  MEETING: "/meetings",
  CLOUD: "/cloud",
  NOTES: "/notes",
  STATS: "/stats",
  LOG: "/logs",
  USER_MANAGEMENT: "/users",
  GROUP_MANAGEMENT: "/groups",
  LDAP_MANAGEMENT: "/ldap",
  BRAND_SETTINGS: "/settings",
  DOCS_GUIDES: "/guides",
};

export const PORTAL_PATH_LIST = Object.values(MENU_PATHS);

const PATH_TO_MENU = Object.entries(MENU_PATHS).reduce((acc, [key, path]) => {
  acc[path] = key;
  return acc;
}, {});

export function normalizePathname(pathname) {
  if (!pathname) return "/";
  const p = String(pathname).split("?")[0].split("#")[0];
  if (p.length > 1 && p.endsWith("/")) return p.slice(0, -1);
  return p || "/";
}

export function menuKeyFromPath(pathname) {
  const p = normalizePathname(pathname);
  if (p === "/" || p === "") return null;
  return PATH_TO_MENU[p] || null;
}

export function pathForMenu(menuKey) {
  return MENU_PATHS[menuKey] || null;
}

/** Toplantı odası / diğer rezervasyon dışı tek segment path */
export function isMeetingRoomPath(pathname) {
  const p = normalizePathname(pathname);
  if (p === "/" || p === "") return false;
  if (PATH_TO_MENU[p]) return false;
  if (p.startsWith("/mobile/")) return true;
  // /register, /login vb. portal dışı ama toplantı değil
  if (
    ["/register", "/login", "/forgot-password", "/verify"].includes(p)
  ) {
    return false;
  }
  // Tek segment → oda id (örn. /abc12xyz)
  const parts = p.replace(/^\//, "").split("/");
  return parts.length === 1 && !!parts[0];
}

export function isPortalPath(pathname) {
  const p = normalizePathname(pathname);
  return p === "/" || !!PATH_TO_MENU[p];
}
